// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"IncidentsTable_tableWrapper__3QFsv","td":"IncidentsTable_td__23dAK","checkboxTd":"IncidentsTable_checkboxTd__1A8lY"};